import Api from '@/api/config.ts';
import { apiUrls } from '@/api/api-urls.ts';
import { Contact, Summary } from '@/api/relation/types.ts';
import { ReportReason } from '@/enums/apiEnums.ts';

export interface ILikesResponse {
  contacts: Contact[];
  next_page_token: string;
}

const getLikesMe = async (
  pageSize?: number,
  pageToken?: string
): Promise<ILikesResponse> => {
  const response = await Api.get<ILikesResponse>(apiUrls.relation.likesMe, {
    params: {
      ...(pageToken && { page_token: pageToken }),
      ...(pageSize && { page_size: pageSize })
    }
  });

  return response.data;
};

const getLikesSent = async (
  pageSize?: number,
  pageToken?: string
): Promise<ILikesResponse> => {
  const response = await Api.get<ILikesResponse>(apiUrls.relation.sentLikes, {
    params: {
      ...(pageToken && { page_token: pageToken }),
      ...(pageSize && { page_size: pageSize })
    }
  });

  return response.data;
};

const getSummariesByKinds = async (kinds: string[]): Promise<Summary[]> => {
  const response = await Api.get<{ summaries: Summary[] }>(
    apiUrls.relation.summaries,
    {
      params: {
        relation_kinds: kinds
      }
    }
  );

  return response.data.summaries;
};

const getContact = async (hid: string) => {
  const response = await Api.get<{ contact: Contact }>(
    apiUrls.relation.getContact(hid)
  );

  return response.data;
};

const blockUser = async (hid: string, reason: ReportReason) => {
  const response = await Api.post<unknown>(apiUrls.relation.blockUser(hid), {
    report_reason: reason
  });

  return response.data;
};

const RelationController = {
  getLikesMe,
  getLikesSent,
  getSummariesByKinds,
  blockUser,
  getContact
};

export default RelationController;
